/**
 * Set up accordion.
 */
class IconicAccordion {
	/**
	 * Class names.
	 *
	 * @type {{}}
	 */
	classes = {
		title: '.iconic-accordion__title',
		item: '.iconic-accordion__item'
	};

	/**
	 * Run accordion.
	 */
	constructor() {
		this.setupAccordions();
	};

	/**
	 * Setup accordions.
	 */
	setupAccordions = () => {
		document.querySelectorAll( this.classes.title ).forEach( ( title ) => {
			title.addEventListener( 'click', ( e ) => {
				title.parentNode.classList.toggle( this.classes.item.replace( '.', '' ) + '--is-open' );

				let panel = title.nextElementSibling;

				if ( panel.style.maxHeight ) {
					panel.style.maxHeight = null;
				} else {
					panel.style.maxHeight = panel.scrollHeight + 'px';
				}
			} );
		} );
	};
}

export {IconicAccordion};